// auth constants

// LOGIN CONSTANTS
export const LOGIN_REQUEST = "LOGIN_REQUEST";
export const LOGIN_SUCCES = "LOGIN_SUCCES";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const LOGOUT = "LOGOUT";

// REGISTER CONSTANTS
export const REGISTER_REQUEST= "REGISTER_REQUEST";
export const REGISTER_SUCCES= "REGISTER_SUCCES";
export const REGISTER_FAIL= "REGISTER_FAIL";

// REFRESH CONSTANTS
export const REFRESH_REQUEST= "REFRESH_REQUEST";
export const REFRESH_SUCCES= "REFRESH_SUCCES";
export const REFRESH_FAIL= "REFRESH_FAIL";

// DETAIL CONSTANTS
export const USER_PROFILE_DETAIL_REQUEST = "USER_PROFILE_DETAIL_REQUEST";
export const USER_PROFILE_DETAIL_SUCCESS = "USER_PROFILE_DETAIL_SUCCESS";
export const USER_PROFILE_DETAIL_FAIL = "USER_PROFILE_DETAIL_FAIL";
